export const KedeDebtStatusEnum = {
  0: "Σε Αναμονή",
  1: "Μη Επιβεβαιωμένο",
  2: "Μη Εξοφλημένο",
  3: "Εξοφλημένο",
  4: "Μη Τερματικό Σφάλμα",
  5: "Τερματικό Σφάλμα",
  6: "Μη Έγκυρος ΑΦΜ",
  7: "Αποβεβαιωμένο",
};

export const MoneyCatalogStatusEnum = {
  0: "Σε Αναμονή",
  1: "Επεξεργασία",
  2: "Ολοκληρώθηκε",
  3: "Απέτυχε",
};

export const MoneyCatalogDetailStatusEnum = {
  0: "Σε Αναμονή",
  1: "Επαληθευμένο",
  2: "Μη Επαληθευμένο",
};

export const SignerStatusEnum = {
  0: "Ανενεργός",
  1: "Ενεργός",
};

export const KedeDiscountStatusEnum = {
  0: "Μη Ολοκληρωμένο",
  1: "Ολοκληρωμένο",
};

export const M06KedeStatusEnum = {
  0: "Σε Αναμονή",
  1: "Μη Επιβεβαιωμένο",
  2: "Μη Εξοφλημένο",
  3: "Εξοφλημένο",
  4: "Σφάλμα",
};
